<div class="dst-dialog" data-testid="sales-target-dialog">

  <div class="dst-head">
    <div>
      <h1 class="dst-title" data-testid="dialog-title">
        {{ (isEditing ? 'dashboard.salesTargetDialog.editTitle' : 'dashboard.salesTargetDialog.createTitle') | transloco }}
      </h1>
      <p class="dst-sub">
        {{ 'dashboard.common.monthYear' | transloco: { month: (('dashboard.months.' + month) | transloco), year: year } }}
      </p>
    </div>
    <button type="button" class="dst-close" (click)="cancel()" [attr.aria-label]="'common.close' | transloco">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6L6 18"/><path d="M6 6l12 12"/></svg>
    </button>
  </div>

  <form class="dst-body" [formGroup]="form" (ngSubmit)="submit()">
    <div class="dst-field">
      <label class="dst-label" for="dst-user">{{ 'dashboard.salesTargetDialog.userLabel' | transloco }}</label>
      <p *ngIf="data.user; else userPicker" class="dst-readonly" id="dst-user" data-testid="dialog-user-name">{{ data.user.name }}</p>
      <ng-template #userPicker>
        <select class="dst-input" id="dst-user" formControlName="userId" data-testid="dialog-user-select">
          <option [ngValue]="null" disabled>{{ 'dashboard.salesTargetDialog.userPlaceholder' | transloco }}</option>
          <option *ngFor="let user of users" [ngValue]="idOf(user)">{{ user.nome || user.username }}</option>
        </select>
        <p *ngIf="usersError" class="dst-error" role="alert" data-testid="dialog-users-error">
          {{ 'dashboard.salesTargetDialog.usersLoadError' | transloco }}
        </p>
      </ng-template>
    </div>

    <div class="dst-field">
      <label class="dst-label" for="dst-value">{{ 'dashboard.salesTargetDialog.valueLabel' | transloco }}</label>
      <input
        class="dst-input dst-tabular"
        id="dst-value"
        type="number"
        min="0"
        step="100"
        formControlName="targetValue"
        data-testid="dialog-value">
      <p class="dst-hint" data-testid="dialog-current">
        <ng-container *ngIf="isEditing; else firstTarget">
          {{ 'dashboard.salesTargetDialog.currentTarget' | transloco: { value: (existingTarget | currency: 'EUR' : 'symbol-narrow' : '1.0-0') } }}
        </ng-container>
        <ng-template #firstTarget>{{ 'dashboard.salesTargetDialog.noTargetYet' | transloco }}</ng-template>
      </p>
      <p
        *ngIf="form.get('targetValue').touched && form.get('targetValue').invalid"
        class="dst-error"
        data-testid="dialog-value-invalid">
        {{ 'dashboard.salesTargetDialog.valueInvalid' | transloco }}
      </p>
    </div>

    <div *ngIf="errorMessage" class="dst-alert" role="alert" data-testid="dialog-error">{{ errorMessage }}</div>
  </form>

  <div class="dst-foot">
    <button type="button" class="dst-btn dst-btn-outline" (click)="cancel()">{{ 'common.cancel' | transloco }}</button>
    <button type="button" class="dst-btn dst-btn-primary" data-testid="dialog-submit" [disabled]="saving" (click)="submit()">
      {{ (isEditing ? 'dashboard.salesTargetDialog.saveChanges' : 'dashboard.salesTargetDialog.create') | transloco }}
    </button>
  </div>

</div>
